export default function CsharpThrow() {
  return (
    <h2>Csharp Throw</h2>
  );
}
